import {ErrorBoundary} from '@/components/ui/error-boundary/index';

export function ClientWrapper({children}: {children: React.ReactNode}) {
    return <ErrorBoundary>{children}</ErrorBoundary>;
}
